export default 'M6 0H0v6h6zm18 18h-6v6h6zM15 0H9v6h6zm3 6h6V0h-6zM6 9H0v6h6zm3 6h6V9H9zm15-6h-6v6h6zM0 24h6v-6H0zm15-6H9v6h6z';